<template>
  <div
    class="card"
    :class="[
      theme ? 'card--theme-' + theme : null
    ]"
  >
    <h2
      class="card__title"
      v-html="product.title"
    />

    <h3 class="card__subtitle">
      {{ parent.name }}
    </h3>

    <ul
      v-if="product.details"
      class="card__detail"
    >
      <li
        v-for="(info, index) in product.details.split(/\s*\|\s*/)"
        :key="index"
      >
        &nbsp;•&nbsp;{{ info }}
      </li>
    </ul>

    <div
      ref="productElement"
      class="card__actions"
    >
      <div
        :id="'container-product-price-' + refId"
        ref="containerProductPrice"
        class="card__price container-product-price"
      />

      <div
        :id="'container-product-link-' + refId"
        ref="containerProductLink"
        class="card__action"
        :class="['container-product-link']"
      />
    </div>

    <p
      v-if="product.legals"
      class="card__legals"
      v-html="product.legals"
    />
  </div>
</template>

<script>
export default {
  props: {
    product: { type: Object, required: true },
    parent: { type: Object, required: true },
    theme: { type: String, default: null },
  },

  computed: {
    globalId() {
      return this.$props.product.globalId;
    },

    refId() {
      return this.globalId.replace(/\|/g, '-');
    },
  },

  mounted() {
    this.addElements();
  },

  methods: {
    addElements() {
      // inject html structure from MDP website
      this.refElement = this.$refs.productElement;
      if (window.products && window.products[this.refId].priceElement && window.products[this.refId].linkElement) {
        document.getElementById(`container-product-price-${this.refId}`).appendChild(window.products[this.refId].priceElement);
        document.getElementById(`container-product-link-${this.refId}`).appendChild(window.products[this.refId].linkElement);
      } else {
        requestAnimationFrame(() => {
          this.addElements();
        });
      }
    },

    elementIsAttachedToDocument(element) {
      while (element !== document && element.parentNode) {
        element = element.parentNode; // eslint-disable-line
      }
      return element === document;
    },
  },
};
</script>

<style lang="stylus" scoped>
.card {
  box-sizing: border-box;
  text-align: left;

  &--theme-green { color: $cl-green; --current-theme:$cl-green;}
  &--theme-purple { color: $cl-purple; --current-theme:$cl-purple; }
  &--theme-orange { color: $cl-orange; --current-theme:$cl-orange; }
}

.card__title {
  @extend $typo-product-card-title;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.card__subtitle {
  @extend $typo-product-card-name;
  margin: 10px 0;
  text-transform: uppercase;
}

.card__detail {
  @extend $typo-product-card-default;
  margin: 10px 0;
}

.card__actions {
  margin: 30px 0;
}

.card__price {
  @extend $typo-product-card-price;

  display: inline-block;
  padding: 14px 18px;
  margin-bottom: 10px;

  border: 1px solid currentColor;
  border-radius: 25px;
}

.card__legals {
  @extend $typo-product-card-legals;
  margin-top: 10px;
}
</style>
